import { EntriFlowStatus } from '@wix/domains-serverless-interface';
import { MobileDomainTaken } from '../../Components/StatusesOverrides/LoggedInMobile/MobileDomainTaken';
import { divertConnectToEntriEligibility } from './connectEntriEligibility';

/**
 * `connect` status override for the logged-in mobile gate.
 *
 * The suite's default `connect` action opens the Entri overlay via
 * `startEntriFlow`. Mobile instead runs a lightweight divert: resolve Entri
 * eligibility, then route to the full-page `/connect-intro` or
 * `/connect-manually` flow. Overriding the action itself (rather than only the
 * card) lets both entry points converge on the same behavior:
 *  - the results card renders `MobileDomainTaken` and clicking runs this action;
 *  - `SelectSiteRoute` runs it imperatively via `useRunDomainAction({ site })`
 *    once a site is picked, so the suite — not the consumer — decides connect
 *    vs. upgrade-paywall for the chosen site.
 *
 * With no site resolved yet (`!msid`) it defers to the consumer's connect
 * handler, which routes to site selection.
 */
export const buildMobileConnectStatus = handlers => {
  const connectStatus = _ref => {
    let {
      domainName,
      msid,
      siteName,
      externalViewer,
      actionHandler
    } = _ref;
    return {
      action: async () => {
        if (!msid) {
          await (actionHandler == null ? void 0 : actionHandler({
            result: EntriFlowStatus.manual,
            domainName,
            externalViewer,
            msid,
            siteName
          }));
          return;
        }
        await divertConnectToEntriEligibility({
          domainName,
          metaSiteId: msid,
          siteName
        }, handlers);
      },
      StatusComponent: MobileDomainTaken
    };
  };

  // The suite's `statusesOverrides` map is keyed by the union `ActionStatus`
  // type; a status-specific factory needs a widening cast (same pattern the
  // suite's own `useRunDomainAction` test uses for `statusesOverrides`).
  return connectStatus;
};
//# sourceMappingURL=mobileConnectStatus.js.map